import React, { useEffect, useContext } from 'react';
import { XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SignInModalContext } from '../App';
interface SignInModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const SignInModal = ({
  isOpen,
  onClose
}: SignInModalProps) => {
  const navigate = useNavigate();
  const {
    openTeacherLoginModal
  } = useContext(SignInModalContext);
  // Check for scroll flag when component mounts or updates
  useEffect(() => {
    if (isOpen) {
      // If we have a flag to scroll to top after sign in, do it now
      const shouldScrollToTop = localStorage.getItem('scrollToTopAfterSignIn') === 'true';
      if (shouldScrollToTop) {
        window.scrollTo(0, 0);
        localStorage.removeItem('scrollToTopAfterSignIn');
      }
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling when modal is closed
      document.body.style.overflow = 'auto';
    }
    // Cleanup function to ensure scrolling is re-enabled
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleLoginClick = (path: string) => {
    // Close the modal first
    onClose();
    // Then navigate to the login page
    navigate(path);
    // Ensure we scroll to top when navigating to login pages
    window.scrollTo(0, 0);
    // Small delay to ensure the scroll happens after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  const handleTeacherLoginClick = () => {
    // Close the sign in modal
    onClose();
    // Open the teacher login modal overlay
    // Use setTimeout to allow the first modal to close smoothly before opening the next
    setTimeout(() => {
      openTeacherLoginModal();
    }, 100);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6" data-id="element-11405">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-navy-900/80 backdrop-blur-sm" onClick={onClose} data-id="element-11406"></div>
      {/* Modal */}
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl relative z-10 animate-fadeIn mx-4 my-auto" data-id="element-11407">
        <div className="flex justify-between items-center mb-6" data-id="element-11408">
          <h3 className="text-2xl font-serif font-bold text-navy-900" data-id="element-11409">
            Sign In
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Close" data-id="element-11410">
            <XIcon className="h-5 w-5" data-id="element-11411" />
          </button>
        </div>
        <p className="text-gray-600 mb-6 text-center" data-id="element-11412">
          Who are you signing in as?
        </p>
        <div className="space-y-4" data-id="element-11413">
          <button onClick={() => handleLoginClick('/student-login')} className="block w-full bg-deep-pink text-white hover:bg-burgundy font-medium py-3 px-4 rounded-lg transition-colors text-center" data-id="element-11414">
            I'm a Student
          </button>
          {/* Teacher button - now opens modal overlay */}
          <button onClick={handleTeacherLoginClick} className="block w-full border border-deep-pink text-deep-pink hover:bg-deep-pink hover:text-white font-medium py-3 px-4 rounded-lg transition-colors text-center" data-id="element-11415">
            I'm a Teacher
          </button>
        </div>
      </div>
    </div>;
};